// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"3d707ebf","453":"8625f1c0","578":"2677a112","608":"94a2f465"}[chunkId] + ".chunk.js";
};